"use strict";

var _typography = require("gatsby-plugin-typography/.cache/typography.js");

var _typography2 = _interopRequireDefault(_typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.onClientEntry = function () {
  // Hot reload typography in development.
  if (process.env.NODE_ENV !== "production") {
    _typography2.default.injectStyles();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/gatsby-browser.js
// module id = 863
// module chunks = 231608221292675